export default {
    general: {
        name: 'Name',
        email: 'Email',
        description: 'Description',
        status: 'Status',
        date: 'Date',
        id: 'ID',
        size: 'Size',
        add: 'Add',
        data: 'Data',
        more_info: 'More information',
        all: 'All',
        clear_filters: 'Clear filters',
        expand_columns: 'Expand columns',
        filter_mode: 'Filter mode',
        filter_contains: 'Contains',
        filter_not_contains: 'Not contains',
        filter_equals: 'Equals',
        filter_not_equals: 'Not equal',
        filter_starts_with: 'Starts with',
        filter_ends_with: 'Ends with',
        filter_less_than: 'Less than',
        filter_less_than_or_equal: 'Less than or equal',
        filter_greater_than: 'Greater than',
        filter_greater_than_or_equal: 'Greater than or equal',
        filter_in_range: 'In range',
        filter_before: 'Before',
        filter_after: 'After',
        filter_from: 'From',
        filter_to: 'To',
        reload: 'Reload',
        reset_column_widths: 'Reset column widths',
        resize_column: 'Resize column',
        search: 'Search',
        yes: 'Yes',
        no: 'No',
        list: 'List',
        download: 'Download',
        approve: 'Approve',
    },
    nav: {
        tasks: 'Tasks',
        projects: 'Projects',
        invoices: 'Invoices',
        submit_request: 'Submit request',
        logout: 'Logout',
    },
    task: {
        list_open: 'Open',
        list_in_confirmation: 'In Confirmation',
        list_finished: 'Finished',
        status_unassigned: 'Unassigned',
        status_open: 'Open',
        status_in_progress: 'In progress',
        status_waiting: 'Waiting',
        status_sent_for_confirmation: 'Sent for confirmation',
        status_confirmed: 'Confirmed',
        status_invoiced: 'Invoiced',
        denied_letter: 'D',
        title: 'Task title',
        branch_office: 'Branch office',
        assigned_user: 'Assigned user',
        added: 'Added',
        deadline: 'Deadline',
        contact: 'Contact',
        adding_failed: 'Request adding failed',
    },
    project: {
        leader: 'Project leader',
        total_tasks: 'Total tasks',
        finished_tasks: 'Finished tasks',
        completed: 'Completed',
        offer_id: 'Offer ID',
        waiting_for_leader: 'Waiting for project leader confirmation',
        waiting_for_client: 'Waiting for client confirmation',
        finished: 'Project finished',
        denial_reason: 'Denial reason:',
    },
    invoice: {
        number_of_tasks: 'Number of tasks',
        invoice_file: 'Invoice',
        times: 'Times',
        transport: 'Transport',
        transport_names: 'Transport types',
        kilometers: 'Kilometers',
        total_time: 'Total time',
        task_ids: 'Task IDs',
        files: 'Files',
        finished: 'Finished',
        approved_by: 'Approved by',
        open_printout: 'Open printout',
    },
    client: {
        select: 'Client',
        change_failed: 'Change failed',
    },
    login: {
        title: 'Login',
        subtitle: 'Welcome back, please login to your account.',
        password: 'Password',
        forgot_password: 'Forgot Password?',
        submit: 'Login',
        failed: 'Login failed',
        language: 'Language',
        reset_password: 'Reset password',
        send_reset_mail: 'Send request',
        reset_text: 'Mail with link and instructions has been sent to you!',
        password_reset_success: 'Password was changed successfully',
        new_password: 'New password',
        reset_mail_already_sent: 'Reset email already sent',
        back_to_login: 'Back to login',
    },
    register: {
        title: 'Register',
        last_name: 'Last name',
        confirm_password: 'Confirm password',
        verification_sent: 'Verification email has been sent!',
        failed: 'Register failed',
    },
    confirm_mail: {
        title: 'Email confirmation',
        confirmed: 'Email address was confirmed successfully!',
        failed: 'Email address could not be confirmed!',
    },
    errors: {
        generic_error: 'An error occurred',
        invalid_data: 'Invalid data',
        not_found: 'Not found',
        on_add: 'Error while adding',
        on_edit: 'Error while updating',
        unauthorized: 'Unauthorized',
        page_not_found: 'Page not found',
        back_home: 'Back to home',
    },
    success: {
        add: 'Successfully added',
        edit: 'Successfully updated',
    },
    validation: {
        required: 'This field is required',
        email: 'Invalid email address',
    },
    brand: {
        product_name: 'ITOMS',
    },
    layout: {
        open_menu: 'Open menu',
        close_menu: 'Close menu',
    },
    color_mode: {
        switch_to_light: 'Switch to light mode',
        switch_to_dark: 'Switch to dark mode',
    },
}
